import { render } from "./signup-email.vue?vue&type=template&id=128cb20b&scoped=true"
import script from "./signup-email.vue?vue&type=script&lang=js"
export * from "./signup-email.vue?vue&type=script&lang=js"

import "./signup-email.vue?vue&type=style&index=0&id=128cb20b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128cb20b"]])

export default __exports__